// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isUndefined = (value: any): boolean => value === undefined

export default isUndefined
